// extracted by mini-css-extract-plugin
export default {"container":"CardDetails_container__jzEXd","detailsImage":"CardDetails_detailsImage__XMR1t"};